module.exports = __webpack_public_path__ + "static/media/jamie-sparker-audition-tapes.416d3997.png";